<template>
    <div class="smartModule">
        <div class="title">
            智能模组
            <div class="line"></div>
        </div>
        <el-tabs class="tabContainer" v-model="activeName">
            <el-tab-pane label="hmi人机界面" name="first">
                <HMI/>
            </el-tab-pane>
            <el-tab-pane label="ARM核心板" name="second">
                <ARM/>
            </el-tab-pane>
            <el-tab-pane label="4G模块" name="third">
                <Module4G/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  import HMI from "./HMI";
  import ARM from "./ARM";
  import Module4G from "./Module4G";

  export default {
    components: {
      HMI,
      ARM,
      Module4G
    },
    data() {
      return {
        activeName: 'first'
      };
    }
  }
</script>

<style lang="less">
    /*为修改element ui标签页默认样式 必须删除关键字scoped*/
    /*注意这个组件没有添加scoped关键字 会污染全局，因此需要把样式写在父组件里*/
    /*注意 子组件会被影响*/
    .smartModule {
        .title {
            text-align: center;
            font-size: 34px;
            color: #595757;
        }

        .line {
            width: 103px;
            background: #e5d276;
            height: 4px;
            margin: 10px auto;
        }
        .el-tabs {
            padding:28px 84px;
        }
    }

    .tabContainer {
        .el-tabs__header {
            padding-bottom: 1px;
            padding-left: 84px;
            border-bottom: 2px solid #aaa;
        }

        .el-tabs__nav-wrap::after {
            background-color: #ffffff;
        }

        .el-tabs__nav {
            width: 100%;
        }

        .el-tabs__item {
            height: 50px;
            line-height: 50px;
            padding: 0 28px !important;
            align-content: center;
        }

        .el-tabs__item.is-active {
            color: black;
            background-color: #EEEEEE;

        }

        .el-tabs__item:hover {
            color: black;
            cursor: pointer;
            background-color: #EEEEEE;
        }

        /*tabs 去掉el-tab-pane切换时的蓝色下划线*/

        .el-tabs__active-bar {
            background-color: transparent !important;
        }

    }

</style>
